import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-acedamiccalendar',
    templateUrl: './acedamiccalendar.component.html',
    styleUrls: ['./acedamiccalendar.component.scss']
})
export class AcedamiccalendarComponent implements OnInit {

    constructor(
        private meta: Meta,
        private titles: Title
    ) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Academic Calendar: Plan Your Year with Key Dates');
        this.meta.updateTag({
            name: 'description',
            content: `Check the ARNI Academic Calendar for important dates, exam schedules, holidays, and events to stay organized and on track throughout the academic year.`
        });
    }

}
